import { CategoryLayout, CategorySub, FaqSettingMinimal } from '@karakuri-web/faq-type'

import { QACategory, QAHeader, QAPanel } from '../components'
import { useFaqRouting } from '../contexts/FaqRoutingContext'
import { values } from '../utils'

/**
 * カテゴリウィジェット用の設定インターフェース
 */
export interface CategoryWidgetSettings extends FaqSettingMinimal {
  categories?: ReadonlyArray<CategorySub> | null
  useMoveToCategoryPageOnClickCategory?: boolean | null
}

interface Props<T extends CategoryWidgetSettings = CategoryWidgetSettings> {
  layout: CategoryLayout
  data: { settingYaml: T }
  path: string
}

/**
 * カテゴリウィジェット
 * カテゴリツリーを表示する
 */
export function CategoryWidget<T extends CategoryWidgetSettings = CategoryWidgetSettings>({
  layout,
  data,
  path,
}: Props<T>) {
  const { navigate } = useFaqRouting()
  const categories = values(data.settingYaml.categories, [])
  if (!categories || categories.length === 0) {
    return null
  }
  const hashId = path.substring(10).replaceAll('/', '')
  const expandable = (c: CategorySub | null): boolean =>
    hashId === c?.id || (c?.sub || []).some(s => expandable(s))
  const isSelected = (id: string) => hashId === id

  const handleCategoryClick = (path: string) =>
    navigate(path.indexOf('category/') === 0 ? `/${path}` : path)

  return (
    <QAPanel className="faq-panel-category" data-testid="faq-panel-category">
      <QAHeader title={layout.title || 'カテゴリから探す'} />
      {categories.map(category => (
        <QACategory
          key={category.id || ''}
          id={category.id || ''}
          title={category.title}
          sub={category.sub}
          isSelected={isSelected}
          expand={expandable(category)}
          checker={expandable}
          onCategoryClick={handleCategoryClick}
          moveToCategoryPageOnCategoryClick={
            data.settingYaml.useMoveToCategoryPageOnClickCategory || false
          }
        />
      ))}
    </QAPanel>
  )
}
